module.exports = __webpack_public_path__ + "static/media/office.a75eb77a.svg";